var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVinilitLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "138px",
    height: "84px",
    viewBox: "-5 0 71 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 347.8,
    y2: 222.3,
    gradientTransform: "matrix(0.172181,0,0,0.175438,0.0577039,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(1.568627%,36.078431%,64.313725%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909091,
    style: {
      stopColor: "rgb(5.490196%,39.607843%,65.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181818,
    style: {
      stopColor: "rgb(9.411765%,43.137255%,67.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272727,
    style: {
      stopColor: "rgb(13.72549%,46.666667%,68.235294%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363636,
    style: {
      stopColor: "rgb(18.431373%,50.196078%,69.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454545,
    style: {
      stopColor: "rgb(22.745098%,53.333333%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545455,
    style: {
      stopColor: "rgb(27.45098%,56.862745%,72.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636364,
    style: {
      stopColor: "rgb(32.54902%,60%,73.333333%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727273,
    style: {
      stopColor: "rgb(37.254902%,63.137255%,74.509804%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818182,
    style: {
      stopColor: "rgb(42.352941%,66.27451%,75.686275%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909091,
    style: {
      stopColor: "rgb(47.843137%,69.411765%,77.254902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(53.333333%,72.156863%,78.431373%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 222.3,
    y2: 0,
    gradientTransform: "matrix(0.172181,0,0,0.175438,0.0577039,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(53.333333%,72.156863%,78.431373%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909091,
    style: {
      stopColor: "rgb(47.843137%,69.411765%,77.254902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181818,
    style: {
      stopColor: "rgb(42.352941%,66.27451%,75.686275%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272727,
    style: {
      stopColor: "rgb(37.254902%,63.137255%,74.509804%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363636,
    style: {
      stopColor: "rgb(32.54902%,60%,73.333333%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454545,
    style: {
      stopColor: "rgb(27.45098%,56.862745%,72.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545455,
    style: {
      stopColor: "rgb(22.745098%,53.333333%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636364,
    style: {
      stopColor: "rgb(18.431373%,50.196078%,69.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727273,
    style: {
      stopColor: "rgb(13.72549%,46.666667%,68.235294%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818182,
    style: {
      stopColor: "rgb(9.411765%,43.137255%,67.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909091,
    style: {
      stopColor: "rgb(5.490196%,39.607843%,65.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(1.568627%,36.078431%,64.313725%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 347.8,
    y2: 222.3,
    gradientTransform: "matrix(0.172181,0,0,0.175438,0.0577039,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.058824%,56.862745%,50.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909091,
    style: {
      stopColor: "rgb(10.588235%,58.823529%,52.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181818,
    style: {
      stopColor: "rgb(14.901961%,60.784314%,54.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272727,
    style: {
      stopColor: "rgb(18.823529%,62.745098%,56.078431%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363636,
    style: {
      stopColor: "rgb(23.137255%,64.705882%,58.039216%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454545,
    style: {
      stopColor: "rgb(27.843137%,66.666667%,60.392157%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545455,
    style: {
      stopColor: "rgb(32.941176%,69.019608%,62.352941%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636364,
    style: {
      stopColor: "rgb(38.039216%,70.980392%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727273,
    style: {
      stopColor: "rgb(43.137255%,72.941176%,67.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818182,
    style: {
      stopColor: "rgb(49.019608%,74.901961%,69.803922%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909091,
    style: {
      stopColor: "rgb(54.901961%,76.862745%,72.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(60.784314%,78.823529%,74.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 347.8,
    y2: 150,
    gradientTransform: "matrix(0.172181,0,0,0.175438,0.0577039,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(60.784314%,78.823529%,74.901961%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909091,
    style: {
      stopColor: "rgb(54.901961%,76.862745%,72.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181818,
    style: {
      stopColor: "rgb(49.019608%,74.901961%,69.803922%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272727,
    style: {
      stopColor: "rgb(43.137255%,72.941176%,67.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363636,
    style: {
      stopColor: "rgb(38.039216%,70.980392%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454545,
    style: {
      stopColor: "rgb(32.941176%,69.019608%,62.352941%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545455,
    style: {
      stopColor: "rgb(27.843137%,66.666667%,60.392157%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636364,
    style: {
      stopColor: "rgb(23.137255%,64.705882%,58.039216%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727273,
    style: {
      stopColor: "rgb(18.823529%,62.745098%,56.078431%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818182,
    style: {
      stopColor: "rgb(14.901961%,60.784314%,54.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909091,
    style: {
      stopColor: "rgb(10.588235%,58.823529%,52.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.058824%,56.862745%,50.588235%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 22.992188 17.054688 C 23.628906 16.753906 24.351562 16.578125 25.128906 16.578125 C 27.847656 16.578125 30.050781 18.773438 30.050781 21.492188 L 30.050781 26.648438 C 30.050781 27.542969 29.3125 28.28125 28.414062 28.28125 C 27.519531 28.28125 26.78125 27.5625 26.78125 26.667969 L 26.78125 21.472656 C 26.78125 20.5625 26.039062 19.84375 25.128906 19.84375 C 24.214844 19.84375 23.492188 20.578125 23.492188 21.472656 L 23.492188 26.667969 C 23.476562 27.5625 22.75 28.28125 21.855469 28.28125 C 20.960938 28.28125 20.21875 27.5625 20.21875 26.667969 L 20.21875 18.210938 C 20.21875 17.316406 20.960938 16.578125 21.855469 16.578125 C 22.269531 16.558594 22.683594 16.753906 22.992188 17.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 7.132812 27.261719 L 7.132812 27.28125 L 7.117188 27.230469 Z M 6.910156 17.632812 L 8.667969 22.140625 L 10.421875 17.613281 L 10.4375 17.59375 C 10.765625 16.753906 11.714844 16.335938 12.558594 16.667969 C 13.402344 16.980469 13.832031 17.929688 13.503906 18.773438 L 13.503906 18.789062 L 10.234375 27.246094 L 10.214844 27.261719 L 10.199219 27.28125 C 9.941406 27.914062 9.320312 28.296875 8.667969 28.296875 C 8.011719 28.296875 7.390625 27.914062 7.132812 27.28125 L 7.132812 27.261719 L 7.117188 27.246094 L 3.847656 18.789062 L 3.847656 18.773438 C 3.519531 17.929688 3.949219 17 4.792969 16.667969 C 5.636719 16.351562 6.582031 16.773438 6.910156 17.59375 Z M 6.910156 17.632812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 36.613281 26.667969 L 36.613281 26.613281 Z M 39.898438 14.246094 L 39.898438 26.648438 C 39.898438 27.542969 39.160156 28.28125 38.265625 28.28125 C 37.367188 28.28125 36.628906 27.5625 36.628906 26.667969 L 36.628906 14.035156 C 36.628906 13.140625 37.367188 12.402344 38.265625 12.402344 C 39.179688 12.402344 39.898438 13.140625 39.898438 14.035156 Z M 39.898438 14.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 31.6875 26.667969 L 31.6875 26.613281 Z M 34.976562 18.230469 L 34.976562 26.648438 C 34.976562 27.542969 34.234375 28.28125 33.339844 28.28125 C 32.445312 28.28125 31.703125 27.5625 31.703125 26.667969 L 31.703125 18.210938 C 31.703125 17.316406 32.445312 16.578125 33.339844 16.578125 C 34.253906 16.578125 34.976562 17.316406 34.976562 18.210938 Z M 34.976562 18.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 31.6875 14.085938 C 31.6875 13.160156 32.429688 12.421875 33.324219 12.421875 C 34.234375 12.421875 34.960938 13.175781 34.960938 14.085938 C 34.960938 15.019531 34.21875 15.753906 33.324219 15.753906 C 32.429688 15.753906 31.6875 15.019531 31.6875 14.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 15.242188 26.667969 L 15.242188 26.613281 Z M 18.53125 18.230469 L 18.53125 26.648438 C 18.53125 27.542969 17.792969 28.28125 16.894531 28.28125 C 16 28.28125 15.261719 27.5625 15.261719 26.667969 L 15.261719 18.210938 C 15.261719 17.316406 16 16.578125 16.894531 16.578125 C 17.808594 16.578125 18.53125 17.316406 18.53125 18.210938 Z M 18.53125 18.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 15.242188 14.085938 C 15.242188 13.160156 15.984375 12.421875 16.878906 12.421875 C 17.792969 12.421875 18.515625 13.175781 18.515625 14.085938 C 18.515625 15.019531 17.773438 15.753906 16.878906 15.753906 C 15.984375 15.753906 15.242188 15.019531 15.242188 14.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 41.535156 26.667969 L 41.535156 26.613281 Z M 44.824219 18.230469 L 44.824219 26.648438 C 44.824219 27.542969 44.082031 28.28125 43.1875 28.28125 C 42.292969 28.28125 41.550781 27.5625 41.550781 26.667969 L 41.550781 18.210938 C 41.550781 17.316406 42.292969 16.578125 43.1875 16.578125 C 44.101562 16.578125 44.824219 17.316406 44.824219 18.210938 Z M 44.824219 18.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 41.535156 14.085938 C 41.535156 13.160156 42.277344 12.421875 43.171875 12.421875 C 44.082031 12.421875 44.808594 13.175781 44.808594 14.085938 C 44.808594 15.019531 44.066406 15.753906 43.171875 15.753906 C 42.277344 15.753906 41.535156 15.019531 41.535156 14.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 53.054688 19.929688 L 49.75 19.929688 L 49.75 23.367188 C 49.75 24.28125 50.488281 25 51.402344 25 C 52.175781 25 52.832031 24.472656 53.003906 23.738281 C 53.140625 22.964844 53.8125 22.386719 54.621094 22.386719 C 55.535156 22.386719 56.257812 23.121094 56.257812 24.019531 C 56.257812 24.160156 56.242188 24.296875 56.207031 24.421875 C 55.726562 26.613281 53.746094 28.261719 51.382812 28.261719 C 48.664062 28.261719 46.460938 26.070312 46.460938 23.351562 L 46.460938 14.035156 C 46.460938 13.140625 47.199219 12.402344 48.097656 12.402344 C 49.007812 12.402344 49.730469 13.140625 49.730469 14.035156 L 49.730469 16.558594 L 53.035156 16.578125 L 53.054688 16.578125 C 53.933594 16.578125 54.65625 17.332031 54.65625 18.246094 C 54.65625 19.175781 53.933594 19.910156 53.054688 19.910156 Z M 53.054688 19.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,37.254902%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 54.640625 14.175781 L 54.898438 14.175781 L 54.898438 13.683594 L 55.15625 13.683594 C 55.34375 13.683594 55.363281 13.753906 55.363281 13.914062 C 55.363281 14.035156 55.378906 14.105469 55.398438 14.160156 L 55.671875 14.160156 C 55.621094 14.105469 55.621094 14.054688 55.621094 13.878906 C 55.621094 13.648438 55.566406 13.613281 55.464844 13.5625 C 55.585938 13.523438 55.65625 13.402344 55.65625 13.261719 C 55.65625 13.160156 55.601562 12.910156 55.277344 12.910156 L 54.640625 12.910156 Z M 54.898438 13.492188 L 54.898438 13.160156 L 55.207031 13.160156 C 55.363281 13.160156 55.378906 13.261719 55.378906 13.316406 C 55.378906 13.441406 55.308594 13.492188 55.191406 13.492188 Z M 54.226562 13.578125 C 54.226562 13.050781 54.621094 12.648438 55.121094 12.648438 C 55.621094 12.648438 56.015625 13.050781 56.015625 13.578125 C 56.015625 14.121094 55.621094 14.507812 55.121094 14.507812 C 54.621094 14.507812 54.226562 14.121094 54.226562 13.578125 M 55.140625 14.703125 C 55.742188 14.703125 56.257812 14.226562 56.257812 13.578125 C 56.257812 12.929688 55.742188 12.457031 55.140625 12.457031 C 54.535156 12.457031 54.019531 12.929688 54.019531 13.578125 C 54.019531 14.226562 54.519531 14.703125 55.140625 14.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 15.207031 6.054688 L 15.175781 6.121094 C 16.8125 5.121094 19.238281 4.945312 22.457031 8.015625 C 29.15625 14.351562 32.238281 6.648438 32.238281 6.648438 L 32.203125 6.667969 L 32.152344 6.753906 C 32.152344 6.753906 29.828125 11.035156 23.320312 5.859375 C 21.476562 4.421875 19.925781 3.859375 18.671875 3.859375 C 17.035156 3.859375 15.882812 4.824219 15.207031 6.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 15.175781 6.15625 L 15.207031 6.140625 L 15.261719 6.054688 C 15.261719 6.054688 17.257812 1.28125 24.144531 6.632812 C 28.414062 9.964844 30.6875 8.824219 32.222656 6.738281 L 32.253906 6.667969 C 30.617188 7.667969 28.191406 7.839844 24.972656 4.773438 C 23.007812 2.945312 21.355469 2.28125 20.011719 2.28125 C 16.726562 2.28125 15.175781 6.15625 15.175781 6.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 28.089844 5.914062 L 28.054688 5.980469 C 29.691406 4.980469 32.117188 4.804688 35.335938 7.875 C 42.035156 14.210938 45.132812 6.492188 45.132812 6.492188 L 45.101562 6.507812 L 45.050781 6.597656 C 45.050781 6.597656 42.722656 10.878906 36.214844 5.699219 C 34.375 4.261719 32.824219 3.703125 31.566406 3.703125 C 29.914062 3.71875 28.761719 4.683594 28.089844 5.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 28.054688 6.085938 L 28.089844 6.070312 L 28.140625 5.980469 C 28.140625 5.980469 30.136719 1.210938 37.023438 6.558594 C 41.292969 9.894531 43.566406 8.753906 45.101562 6.667969 L 45.132812 6.597656 C 43.5 7.597656 41.070312 7.773438 37.851562 4.703125 C 35.90625 2.859375 34.253906 2.191406 32.910156 2.191406 C 29.605469 2.210938 28.054688 6.085938 28.054688 6.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,45.490196%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 22.027344 34.386719 C 22.027344 35.175781 21.425781 35.808594 20.703125 35.808594 C 20.253906 35.808594 19.910156 35.597656 19.703125 35.28125 L 19.703125 35.738281 L 19.238281 35.738281 L 19.238281 32.019531 L 19.703125 32.019531 L 19.703125 33.507812 C 19.910156 33.175781 20.253906 32.984375 20.703125 32.984375 C 21.425781 32.964844 22.027344 33.597656 22.027344 34.386719 M 21.582031 34.386719 C 21.582031 33.839844 21.167969 33.421875 20.652344 33.421875 C 20.117188 33.421875 19.71875 33.839844 19.71875 34.386719 C 19.71875 34.929688 20.136719 35.351562 20.652344 35.351562 C 21.167969 35.351562 21.582031 34.929688 21.582031 34.386719 M 24.695312 33.035156 L 23.628906 35.894531 C 23.40625 36.492188 22.992188 36.839844 22.457031 36.808594 L 22.457031 36.367188 C 22.820312 36.402344 23.027344 36.175781 23.164062 35.824219 L 23.21875 35.71875 L 22.0625 33.050781 L 22.542969 33.050781 L 23.441406 35.15625 L 24.195312 33.050781 L 24.695312 33.050781 Z M 35.527344 34.335938 L 34.632812 33.050781 L 35.421875 33.050781 L 35.972656 33.839844 L 36.507812 33.050781 L 37.25 33.050781 L 36.355469 34.386719 L 37.300781 35.738281 L 36.507812 35.738281 L 35.90625 34.878906 L 35.335938 35.738281 L 34.597656 35.738281 Z M 39.296875 34.894531 C 39.382812 35.105469 39.539062 35.246094 39.796875 35.226562 C 39.988281 35.226562 40.105469 35.140625 40.105469 35 C 40.105469 34.824219 40.003906 34.773438 39.640625 34.613281 C 39.179688 34.4375 38.867188 34.175781 38.867188 33.753906 C 38.867188 33.316406 39.195312 32.964844 39.761719 32.964844 C 40.332031 32.964844 40.65625 33.210938 40.726562 33.613281 L 40.210938 33.839844 C 40.15625 33.632812 40.003906 33.523438 39.78125 33.523438 C 39.605469 33.523438 39.503906 33.613281 39.503906 33.738281 C 39.503906 33.878906 39.640625 33.945312 39.953125 34.085938 C 40.417969 34.28125 40.742188 34.527344 40.742188 34.980469 C 40.742188 35.367188 40.433594 35.808594 39.78125 35.808594 C 39.28125 35.808594 38.867188 35.558594 38.761719 35.15625 Z M 30.277344 35.71875 L 30.964844 35.71875 L 30.964844 33.035156 L 30.277344 33.035156 Z M 30.277344 32.597656 L 30.964844 32.597656 L 30.964844 31.894531 L 30.277344 31.894531 Z M 37.660156 35.71875 L 38.351562 35.71875 L 38.351562 33.035156 L 37.660156 33.035156 Z M 37.660156 32.597656 L 38.351562 32.597656 L 38.351562 31.894531 L 37.660156 31.894531 Z M 28.984375 31.894531 L 29.671875 31.894531 L 29.671875 35.738281 L 28.984375 35.738281 Z M 27.710938 33.035156 L 27.710938 33.316406 C 27.605469 33.160156 27.277344 32.964844 26.882812 32.964844 C 26.230469 32.964844 25.589844 33.542969 25.558594 34.296875 C 25.558594 34.316406 25.558594 34.351562 25.558594 34.367188 C 25.558594 34.386719 25.558594 34.421875 25.558594 34.4375 C 25.589844 35.210938 26.246094 35.773438 26.882812 35.773438 C 27.261719 35.773438 27.589844 35.578125 27.710938 35.421875 L 27.710938 35.699219 L 28.398438 35.699219 L 28.398438 33.019531 L 27.710938 33.019531 Z M 26.96875 35.175781 C 26.558594 35.175781 26.210938 34.824219 26.210938 34.386719 C 26.210938 33.945312 26.558594 33.597656 26.96875 33.597656 C 27.382812 33.597656 27.726562 33.945312 27.726562 34.386719 C 27.710938 34.824219 27.382812 35.175781 26.96875 35.175781 M 33.53125 33.035156 L 33.53125 33.316406 C 33.425781 33.160156 33.097656 32.964844 32.703125 32.964844 C 32.046875 32.964844 31.410156 33.542969 31.378906 34.296875 C 31.378906 34.316406 31.378906 34.351562 31.378906 34.367188 C 31.378906 34.386719 31.378906 34.421875 31.378906 34.4375 C 31.410156 35.210938 32.066406 35.773438 32.703125 35.773438 C 33.082031 35.773438 33.410156 35.578125 33.53125 35.421875 L 33.53125 35.699219 L 34.21875 35.699219 L 34.21875 33.019531 L 33.53125 33.019531 Z M 32.773438 35.175781 C 32.359375 35.175781 32.015625 34.824219 32.015625 34.386719 C 32.015625 33.945312 32.359375 33.597656 32.773438 33.597656 C 33.183594 33.597656 33.53125 33.945312 33.53125 34.386719 C 33.53125 34.824219 33.183594 35.175781 32.773438 35.175781 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinilitLogo);
export default __webpack_public_path__ + "static/media/Vinilit-logo.4f4bf6b9bcd7f04d0da8329ab5fe9548.svg";
export { ForwardRef as ReactComponent };